import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import snoopDogg from "@/assets/clients/snoop-dogg.jpg";
import lameloBall from "@/assets/clients/lamelo-ball.jpg";
import bradPitt from "@/assets/clients/brad-pitt.jpg";

const clients = [
  { name: "Snoop Dogg", role: "Artist & Entrepreneur", image: snoopDogg, alt: "Snoop Dogg — celebrity client of Hyper Haus automotive customization" },
  { name: "LaMelo Ball", role: "NBA Star", image: lameloBall, alt: "LaMelo Ball — NBA star and Hyper Haus client" },
  { name: "Brad Pitt", role: "Actor & Producer", image: bradPitt, alt: "Brad Pitt — actor and Hyper Haus automotive protection client" },
];

const partners = [
  { name: "Pagani Beverly Hills", type: "Dealership Partner" },
  { name: "Ancillary Studio", type: "Production Partner" },
];

const Clients = () => {
  return (
    <section className="py-24 bg-card">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-primary text-sm uppercase tracking-[0.3em] mb-4">Trusted By</p>
          <h2 className="section-heading mb-4">Elite Clientele</h2>
          <p className="section-subheading mx-auto">
            Serving celebrities, athletes, and the world's most prestigious dealerships.
          </p>
        </motion.div>

        {/* Celebrity Clients */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {clients.map((client, index) => (
            <motion.div
              key={client.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="card-luxury p-8 rounded-lg text-center"
            >
              <div className="w-16 h-16 mx-auto mb-4 rounded-full overflow-hidden">
                <img src={client.image} alt={client.alt} loading="lazy" width={64} height={64} className="w-full h-full object-cover" />
              </div>
              <h3 className="font-display-sm text-xl mb-1">{client.name}</h3>
              <p className="text-sm text-muted-foreground">{client.role}</p>
            </motion.div>
          ))}
        </div>

        {/* Partners */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="border-t border-border pt-16"
        >
          <p className="text-center text-sm uppercase tracking-wider text-muted-foreground mb-8">
            Dealership & Studio Partners
          </p>
          <div className="flex flex-wrap justify-center gap-12">
            {partners.map((partner) => (
              <div key={partner.name} className="text-center">
                <p className="font-display text-2xl">{partner.name}</p>
                <p className="text-xs text-muted-foreground mt-1">{partner.type}</p>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Testimonial Placeholder */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-16 max-w-2xl mx-auto text-center"
        >
          <Quote className="w-10 h-10 text-primary/30 mx-auto mb-4" />
          <p className="text-xl italic text-muted-foreground mb-4">
            "Reviews coming soon from our valued clients and partners."
          </p>
          <p className="text-sm text-muted-foreground">— Hyper Haus</p>
        </motion.div>
      </div>
    </section>
  );
};

export default Clients;
